import { render, staticRenderFns } from "./LimitRequestDetail.vue?vue&type=template&id=7155cce3&scoped=true&"
import script from "./LimitRequestDetail.vue?vue&type=script&lang=js&"
export * from "./LimitRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./LimitRequestDetail.vue?vue&type=style&index=0&id=7155cce3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7155cce3",
  null
  
)

export default component.exports